/* eslint-disable @typescript-eslint/indent*/
import { DateTime } from 'luxon';

type Scale = 'year' | 'month' | 'week' | 'day' | 'hour' | 'minute';
export const BudgetRanges: Record<
    string,
    {
        scale: Scale;
        since: (created: DateTime) => DateTime;
        until: (created: DateTime) => DateTime;
    }
> = {
    daily: {
        scale: 'day',
        since: (created) => created.startOf('day'),
        until: (created) => undefined,
    },
    weekly: {
        scale: 'month',
        since: (created) => created.startOf('week'),
        until: (created) => created.plus({ weeks: 1 }).startOf('week'),
    },
    monthly: {
        scale: 'month',
        since: (created) => created.startOf('month'),
        until: (created) => undefined,
    },
    bimonthly: {
        scale: 'month',
        since: (created) => {
            if (created.month % 2 === 0) {
                return created.minus({ months: 1 }).startOf('month');
            }
            return created.startOf('month');
        },
        until: (created) => {
            if (created.month % 2 === 0) {
                return created.plus({ months: 1 }).startOf('month');
            }
            return created.plus({ months: 2 }).startOf('month');
        },
    },
    quarterly: {
        scale: 'month',
        since: (created) => {
            if (created.month % 3 === 0) {
                return created.minus({ months: 2 }).startOf('month');
            } else if (created.month % 3 === 1) {
                return created.startOf('month');
            }
            return created.minus({ months: 1 }).startOf('month');
        },
        until: (created) => {
            if (created.month % 3 === 0) {
                return created.plus({ months: 1 }).startOf('month');
            } else if (created.month % 3 === 1) {
                return created.plus({ months: 3 }).startOf('month');
            }
            return created.plus({ months: 2 }).startOf('month');
        },
    },
    yearly: {
        scale: 'year',
        since: (created) => created.startOf('year'),
        until: () => undefined,
    },
};
